var TabsCommercial = function() {

	this.init = function() {

		this.tabs();

		this.details();

		if($(window).width() < 1025) {
			this.mobile();
		}


	};

	this.tabs = function(){

		$('.tabs li').on('click', function(){
			var tab_id = $(this).attr('data-tab');

			$('.tabs li').removeClass('current');
			$('.tab-content').removeClass('current');

			$(this).addClass('current');
			$("#" + tab_id).addClass('current');
		});

	};

	this.details = function(){

		$('.more').on('click', function(){

			$(this).find('.btn-more').toggleClass('less');
			$(this).next('.detail').slideToggle(300);

		});

	};

	this.mobile = function(){

		$('.head').on('click', function(){

			$(this).toggleClass('less');
			$(this).parent().find('.box').slideToggle(300);

		});

	};

	return this.init();

};
